import dayjs from 'dayjs'
import { cm } from '~/utils/utils'

export interface DividerBlockProps {
  fields: {
    date: number | string
  }
}

export function DividerBlock({ fields }: DividerBlockProps) {
  const renderDate = (date: number | string) => {
    if (typeof date === 'string') return date
    if (typeof date === 'number') {
      return dayjs(date).format('h:mm A, MMM DD, YYYY')
    }
  }
  return (
    <div className={cm('flex items-center my-5 mx-[40px]')}>
      <div className='border-t border-gray-300 w-full opacity-45' />
      <div className=' text-gray-500 text-xs text-nowrap border rounded-2xl px-3 py-[4px]'>
        {renderDate(fields.date)}
      </div>
      <div className='border-t border-gray-300 w-full opacity-45' />
    </div>
  )
}
